import React from 'react'

export default ({errors = []}) => {
    return (
        <div>
            { errors.map(function (error, index) {
                return (
                    <div key={index}
                         className="help-block error">{error}</div>
                )
            })}
        </div>
    )
}
